import { useEffect } from "react";
import { useDebounceValue } from "usehooks-ts";
import { useCheckMcpSlugMutation } from "../api/hooks";

export const useSlugValidation = (slug: string, originalSlug?: string) => {
  const DEBOUNCE_MS = 400;
  const [debouncedSlug] = useDebounceValue(slug, DEBOUNCE_MS);
  const { mutate, data, isPending, error } = useCheckMcpSlugMutation();

  const shouldValidate = debouncedSlug && debouncedSlug !== originalSlug;

  useEffect(() => {
    if (shouldValidate) {
      mutate({ slug: debouncedSlug });
    }
  }, [debouncedSlug, mutate, shouldValidate]);

  const parseErrorMessage = (apiMessage: string): string => {
    if (apiMessage.includes("'startsnotwith' tag")) {
      return "Slug cannot start with 'gw_'";
    }
    if (apiMessage.includes("'slug' tag")) {
      return "Slug cannot contain profanity or restricted words like 'arcade'";
    }

    return apiMessage;
  };

  const rawErrorMessage =
    // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
    (error as { response?: { data?: { message?: string } } })?.response?.data
      ?.message;
  const errorMessage = rawErrorMessage
    ? parseErrorMessage(rawErrorMessage)
    : null;

  return {
    isValidating: shouldValidate && isPending,
    isAvailable: shouldValidate ? data?.available : undefined,
    shouldShowIndicator: shouldValidate,
    validationData: data,
    error: errorMessage,
    hasError: !!errorMessage,
  };
};
